module.exports = __webpack_public_path__ + "static/media/game-help-icon.bcf8aa83.svg";